import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const state = {
  userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
  token: '',
  navItem: 1,
  tabIndex: 0,
  exiOid: '',
  showSelect: true,
  showBanner: true,
  isEditExi: 0,
  deleteExi: '',
  singniorcheck: '',
  showLive: 0,
  ifUserPortal: false,//是否是客户门户
  originList: ['http://ch-hpe.zhanxiaobang.cn'],
  target: '_blank'

}
const getters = {
  userData(state) {
    return state.userInfo
  }
}
const mutations = {
  // 设置导航栏用户信息
  updateUserInfo(state, userData) {
    state.userInfo = userData
  },
  // 退出登录
  loginOut(state) {
    state.token = null;
    state.userInfo = '';
    localStorage.removeItem('token')
  },
  setNavClass(state, index) {
    state.tabIndex = index
  },
  setExiOid(state, oid) {
    state.exiOid = oid
  },
  setShowLive(state, status) {
    state.showLive = status;
  },
  setNavSelect(state, data) {
    state.showSelect = data
  },
  setShowBanner(state, data) {
    state.showBanner = data;
  },
  setifUserPortal(state, data) {
    state.ifUserPortal = data;
  },
  editExi(state, data) {
    state.isEditExi = data.number;
    if (data.oid) {
      state.deleteExi = data.oid;
    }
  }
}
const actions = {
  commitUpdateUserInfo({commit}, userData) {
    commit('updateUserInfo', userData)
    localStorage.setItem('userInfo', JSON.stringify(userData))
  },
}
const store = new Vuex.Store({
  state,
  actions,
  getters,
  mutations
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js